import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["componentClass", "grid", "clsPrefix", "direction", "gutter", "wrap", "align", "justify", "className"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
import { detectFlexGapSupported } from "./utils";
import RowContext from "./RowContext";
var propTypes = {
  componentClass: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  grid: PropTypes.oneOf([12, 24])
};
var defaultProps = {
  componentClass: 'div',
  grid: 24
};
var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
var Row = (_dec = WebUI({
  name: "row",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Row, _Component);

  var _super = _createSuper(Row);

  function Row(props) {
    var _this;

    _classCallCheck(this, Row);

    _this = _super.call(this, props);
    _this.state = {
      supportFlexGap: false
    };
    return _this;
  }

  _createClass(Row, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        supportFlexGap: detectFlexGapSupported()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var supportFlexGap = this.state.supportFlexGap;

      var _this$props = this.props,
          Component = _this$props.componentClass,
          grid = _this$props.grid,
          clsPrefix = _this$props.clsPrefix,
          direction = _this$props.direction,
          _this$props$gutter = _this$props.gutter,
          gutter = _this$props$gutter === void 0 ? 0 : _this$props$gutter,
          wrap = _this$props.wrap,
          align = _this$props.align,
          justify = _this$props.justify,
          className = _this$props.className,
          others = _objectWithoutProperties(_this$props, _excluded);

      var getGutter = function getGutter() {
        var results = [0, 0];
        var normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
        normalizedGutter.forEach(function (g, index) {
          if (_typeof(g) === 'object') {
            for (var i = 0; i < responsiveArray.length; i++) {
              var breakpoint = responsiveArray[i];

              if (screens[breakpoint] && g[breakpoint] !== undefined) {
                results[index] = g[breakpoint];
                break;
              }
            }
          } else {
            results[index] = g || 0;
          }
        });
        return results;
      };

      var gutters = getGutter();
      var classes = classNames(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-no-wrap"), wrap === false), _defineProperty(_classNames, "".concat(clsPrefix, "-").concat(justify), justify), _defineProperty(_classNames, "".concat(clsPrefix, "-").concat(align), align), _defineProperty(_classNames, "".concat(clsPrefix, "-rtl"), direction === 'rtl'), _classNames), className); // Add gutter related style

      var rowStyle = {};
      var horizontalGutter = gutters[0] > 0 ? gutters[0] / -2 : undefined;
      var verticalGutter = gutters[1] > 0 ? gutters[1] / -2 : undefined;

      if (horizontalGutter) {
        rowStyle.marginLeft = horizontalGutter;
        rowStyle.marginRight = horizontalGutter;
      }

      if (supportFlexGap) {
        // Set gap direct if flex gap support
        var _gutters = _slicedToArray(gutters, 2);

        rowStyle.rowGap = _gutters[1];
      } else if (verticalGutter) {
        rowStyle.marginTop = verticalGutter;
        rowStyle.marginBottom = verticalGutter;
      }

      var rowContext = {
        gutter: gutters,
        wrap: wrap,
        supportFlexGap: supportFlexGap
      };
      var extralClass = grid === 12 ? "".concat(clsPrefix, "-").concat(grid) : "";
      return /*#__PURE__*/React.createElement(RowContext.Provider, {
        value: rowContext
      }, /*#__PURE__*/React.createElement(Component, _extends({}, others, {
        className: classNames(classes, className, extralClass)
      }), this.props.children));
    }
  }]);

  return Row;
}(Component)) || _class);
Row.displayName = 'Row';
Row.propTypes = propTypes;
export default Row;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-layout/src/Row.js